import './binding-handlers/workqueue';
import './fragments/clockout';
import initializeHome from './home/index';
import './style.less';
import { parse, settings } from './config';
import { handle as handleReady } from '../main/events/ready';

interface ShopfloorExports {
	strings: any;
}

jQuery(function shopfloor() {
	handleReady(async () => {
		parse(jQuery("#shopfloor-config").text());

		let shopFloorexports: ShopfloorExports = {
			strings: settings && settings.strings
		};

		window['konfig'].shopfloor = shopFloorexports;
	
		await initializeHome();
	})
})